import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

export interface HydraCheckIfEmailIsTakenProps {
  email: string
}

export const HydraCheckIfEmailIsTaken = async ({
  email,
}: HydraCheckIfEmailIsTakenProps) => {
  // Email is passed as query parameter, so we need to encode it.
  // Plus signs for example, would get passed as a blank space otherwise.
  const encodedEmail = encodeURIComponent(email)

  const request: SendRequestType = {
    method: 'HEAD',
    url: `/customers?email=${encodedEmail}`,
    withAuth: false,
    returnType: 'response',
  }

  return httpTools.sendRequest<Response>(request)
}
